import React from 'react'
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import StoryDetails from '../index'
import moment from 'moment'

class StoryDetailsContainer extends React.Component{
  render(){
    return (
      <StoryDetails
        stories={this.props.stories}
        story={this.props.story}
        returnTo={"/a/"+this.props.account_id}
      />
    )
  }
}

const mapStateToProps = function (state, props) {
  let stories=props.stories.sort((a,b)=>moment(b.posted_at).toDate()-moment(a.posted_at).toDate())
  return {
    account_id:props.match.params.id,
    stories,
    user:state.user.userData,
    story:props.stories.find(s=>s.id===props.match.params.storyId)
  };
}

export default connect(mapStateToProps)(withRouter(StoryDetailsContainer));



// WEBPACK FOOTER //
// ./src/components/account_page/story_details/containers/story.js